import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Button } from "@components/ui/button";
import { AlertTriangle } from "lucide-react";

interface SetupDialogProps {
  handleNavigateFromRequiredInfo: (tabValue: string) => void;
  showRequiredInfoModal: boolean;
  closeRequiredInfoModal: () => void;
}

const SetupDialog = ({
  handleNavigateFromRequiredInfo,
  showRequiredInfoModal,
  closeRequiredInfoModal,
}: SetupDialogProps) => {
  return (
    <Dialog
      open={showRequiredInfoModal}
      onOpenChange={(open) => {
        if (!open) closeRequiredInfoModal();
      }}
    >
      <DialogContent className="sm:max-w-md font-montserrat bg-white">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="flex items-center justify-center h-11 w-11 rounded-full bg-[#FFF4E5] shrink-0">
              <AlertTriangle className="h-5 w-5 text-[#EFBF04]" />
            </div>
            <DialogTitle className="text-charcoal font-bold">
              One more step
            </DialogTitle>
          </div>
          <DialogDescription className="text-sm text-[#525252] leading-relaxed pt-2">
            To proceed to the dashboard, please add at least your{" "}
            <span className="font-semibold text-charcoal">Work Experience</span>{" "}
            or{" "}
            <span className="font-semibold text-charcoal">
              Education / Certification
            </span>
            .
          </DialogDescription>
          <p className="text-xs text-[#737373]">
            This helps us match you with the most relevant opportunities. Choose
            where you'd like to start:
          </p>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={closeRequiredInfoModal}>
            Not now
          </Button>
          <Button
            variant="outline"
            className="border-primary text-primary hover:text-primary"
            onClick={() => handleNavigateFromRequiredInfo("education")}
          >
            Add Education
          </Button>
          <Button onClick={() => handleNavigateFromRequiredInfo("experience")}>
            Add Experience
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SetupDialog;
